interface SchemaOrgProps {
  type: "Organization" | "WebSite" | "WebPage" | "BreadcrumbList" | "Article" | "FAQPage";
  data: Record<string, unknown>;
  scriptId?: string;
}

export default function SchemaOrg({ type, data, scriptId }: SchemaOrgProps) {
  const schema = {
    "@context": "https://schema.org",
    "@type": type,
    ...data,
  };

  return (
    <script
      type="application/ld+json"
      id={scriptId}
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema, null, 2) }}
    />
  );
}